import { useState as useState } from 'react';
import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  getLocalDelegateReference2ls94nvl5ojb2 as getLocalDelegateReference,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { round2mrvepag8eey0 as round } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  component11cgra71sux02t as component1,
  component21bl9a2wgotvv9 as component2,
  component31p8u65el5igun as component3,
} from './FrameRunnerPropsExtentions.mjs';
import { firstqtqxwgtggxw8 as first } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { useEffectOncetplizg4bhfpf as useEffectOnce } from '../../../../../../kotlin-react/react/useEffect.mjs';
import { addChildNodeajp8y977cuss as addChildNode } from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_FrameRunner() {
  _init_properties_FrameRunner_kt__164xqj();
  var tmp = KProperty0();
  return FrameRunner$delegate.getValue_u7qj63_k$(null, getPropertyCallableRef('FrameRunner', 0, tmp, _get_FrameRunner_$ref_j0e3lp(), null));
}
var FrameRunner$delegate;
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ {
      constructor(data, delay) {
        this.data_1 = data;
        this.delay_1 = delay;
      }
      component1_7eebsc_k$() {
        return this.data_1;
      }
      component2_7eebsb_k$() {
        return this.delay_1;
      }
      toString() {
        return 'Frame(data=' + toString(this.data_1) + ', delay=' + this.delay_1 + ')';
      }
      hashCode() {
        var result = this.data_1 == null ? 0 : hashCode(this.data_1);
        result = imul(result, 31) + this.delay_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Frame()))
          return false;
        if (!equals(this.data_1, other.data_1))
          return false;
        if (!(this.delay_1 === other.delay_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
function scheduleStateFunc(setState, speed) {
  _init_properties_FrameRunner_kt__164xqj();
  var tmp = statePairToTimeoutArgsFunc(setState);
  var tmp_0 = join(tmp, pairTransformSecondFunc((it) => applySpeed(it, speed)));
  return join(tmp_0, scheduleStateFunc$lambda);
}
function join(_this__u8e3s4, transform) {
  _init_properties_FrameRunner_kt__164xqj();
  return (pair) => transform(_this__u8e3s4(pair));
}
function statePairToTimeoutArgsFunc(_this__u8e3s4) {
  _init_properties_FrameRunner_kt__164xqj();
  return toFrameFunc(pairTransformFirstFunc(curryOneArgToNoArgsFunc(_this__u8e3s4)));
}
function pairTransformSecondFunc(transform) {
  _init_properties_FrameRunner_kt__164xqj();
  return (pair) => letSecond(pair, transform);
}
function applySpeed(_this__u8e3s4, speed) {
  _init_properties_FrameRunner_kt__164xqj();
  return numberToInt(round(_this__u8e3s4 / speed));
}
function let_0(_this__u8e3s4, transform) {
  _init_properties_FrameRunner_kt__164xqj();
  return transform(_this__u8e3s4.first_1, _this__u8e3s4.second_1);
}
function setTimeout(timedFunc, time) {
  _init_properties_FrameRunner_kt__164xqj();
  return window.setTimeout(timedFunc, time);
}
function toFrameFunc(target) {
  _init_properties_FrameRunner_kt__164xqj();
  return (it) => target(new (Pair())(it.data_1, it.delay_1));
}
function pairTransformFirstFunc(transform) {
  _init_properties_FrameRunner_kt__164xqj();
  return (pair) => letFirst(pair, transform);
}
function curryOneArgToNoArgsFunc(_this__u8e3s4) {
  _init_properties_FrameRunner_kt__164xqj();
  return (it) => () => {
    _this__u8e3s4(it);
    return Unit_instance;
  };
}
function letSecond(_this__u8e3s4, transform) {
  _init_properties_FrameRunner_kt__164xqj();
  return to(_this__u8e3s4.first_1, transform(_this__u8e3s4.second_1));
}
function letFirst(_this__u8e3s4, transform) {
  _init_properties_FrameRunner_kt__164xqj();
  return to(transform(_this__u8e3s4.first_1), _this__u8e3s4.second_1);
}
function FrameRunner$delegate$lambda($this$nfc, props) {
  _init_properties_FrameRunner_kt__164xqj();
  var sequence = component1(props);
  var speed = component2(props);
  var children = component3(props);
  var state$delegate = useState(first(sequence).data_1);
  var scheduleStateFunc_0 = scheduleStateFunc((it) => {
    invoke$lambda_0(state$delegate, it);
    return Unit_instance;
  }, speed);
  useEffectOnce(FrameRunner$delegate$lambda$slambda(sequence, scheduleStateFunc_0));
  // Inline function 'react.ChildrenBuilder.unaryPlus' call
  var this_0 = children(invoke$lambda(state$delegate));
  addChildNode($this$nfc, this_0);
  return Unit_instance;
}
function invoke$lambda($state$delegate) {
  _init_properties_FrameRunner_kt__164xqj();
  // Inline function 'react.StateInstance.getValue' call
  getLocalDelegateReference('state', KMutableProperty0(), true);
  // Inline function 'kotlin.js.asDynamic' call
  return $state$delegate[0];
}
function invoke$lambda_0($state$delegate, _set____db54di) {
  _init_properties_FrameRunner_kt__164xqj();
  // Inline function 'react.StateInstance.setValue' call
  getLocalDelegateReference('state', KMutableProperty0(), true);
  // Inline function 'kotlin.js.asDynamic' call
  $state$delegate[1](_set____db54di);
  return Unit_instance;
}
function FrameRunner$delegate$lambda$slambda($sequence, $scheduleStateFunc) {
  return constructCallableReference(($this$useEffectOnce, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $sequence;
    // Inline function 'kotlin.sequences.forEach' call
    var action = $scheduleStateFunc;
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      action(element);
    }
    return Unit_instance;
  }), 1);
}
function _get_FrameRunner_$ref_j0e3lp() {
  return constructCallableReference(() => get_FrameRunner(), 0, 0, 106);
}
function scheduleStateFunc$lambda(args) {
  _init_properties_FrameRunner_kt__164xqj();
  let_0(args, setTimeout$ref());
  return Unit_instance;
}
function setTimeout$ref() {
  return constructCallableReference((p0, p1) => setTimeout(p0, p1), 2, 0, 107, 'setTimeout');
}
var properties_initialized_FrameRunner_kt_5wmwwd;
function _init_properties_FrameRunner_kt__164xqj() {
  if (!properties_initialized_FrameRunner_kt_5wmwwd) {
    properties_initialized_FrameRunner_kt_5wmwwd = true;
    FrameRunner$delegate = nfc(FrameRunner$delegate$lambda);
  }
}
//region block: exports
export {
  get_FrameRunner as get_FrameRunner1vxxn1vgayqf,
  Frame as Frame1ci3gictglus,
};
//endregion

//# sourceMappingURL=FrameRunner.mjs.map
